import CategoryCard from '../../components/cards/v2/category.card';
import DiscoverSection from '../../components/containers/discover/section.discover';
import Header from '../../components/header/default.header';
import HorizontalBar from '../../components/horizontalBar';
import { HStack } from '../../components/layouts/stack.layout';
import MainLayout from '../../components/layouts/v2/main.layout';
import AlternativeNavigation from '../../components/navigation/alternative.navigation';
import { genres, recommendedArtists, subscriptions } from '../../test.data';

export default function Categories() {
  return (
    <MainLayout title="Releases" layout="alt">
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main className="flex flex-col gap-10 py-4">
          <DiscoverSection gap="sm" title="Genre">
            <HStack gap="base" extensions="overflow-auto items-center">
              {genres.map((genre) => (
                <CategoryCard
                  key={genre.title}
                  path={genre.title}
                  title={genre.title}
                  imageSrc={genre.thumbnail}
                />
              ))}
            </HStack>
          </DiscoverSection>
          <HorizontalBar />
          <DiscoverSection gap="sm" title="Artists">
            <HStack gap="base" extensions="overflow-auto items-center">
              {subscriptions.map((subscription) => (
                <CategoryCard
                  key={subscription.username}
                  path={`/${subscription.username}?tab=releases`}
                  title={subscription.displayName}
                  imageSrc={subscription.avatarUrl}
                />
              ))}
            </HStack>
          </DiscoverSection>
          <HorizontalBar />
          <DiscoverSection gap="sm" title="Recommended">
            <HStack gap="base" extensions="overflow-auto items-center">
              {recommendedArtists.map((recommendedArtist) => (
                <CategoryCard
                  key={recommendedArtist.username}
                  path={`/${recommendedArtist.username}?tab=releases`}
                  title={recommendedArtist.displayName}
                  imageSrc={recommendedArtist.avatarUrl}
                />
              ))}
            </HStack>
          </DiscoverSection>
        </MainLayout.Main>
      </MainLayout.Content>
    </MainLayout>
  );
}
